/* eslint-disable max-lines-per-function */
/**
 * @file  Investor
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React, {useState, useEffect, useContext} from 'react';
import {useHistory} from 'react-router-dom';
import {
    Form,
    Input,
    Checkbox,
    Button,
    message,
    Divider
} from 'antd';
import {saveSubscribe} from '~/service/subscription';
import {BasicLayoutContext} from '~/layout/BasicLayout';

import './index.less';

const plainOptions = [
    'All Alert',
    'News Releases',
    'SEC Filings'
];

function Investor() {
    const [form] = Form.useForm();
    const history = useHistory();
    const [checkedList, setCheckedList] = useState([]);
    const layoutContext = useContext(BasicLayoutContext);
    const {isMobile} = layoutContext ?? {};

    useEffect(() => {
        window.scrollTo(0, 0);
    });

    async function handleSubmit() {
        const params = await form.validateFields();
        const {alertsType} = params;
        const alertsTypeCode = [];
        alertsType.map(item => {
            switch (item) {
                case 'News Releases': alertsTypeCode.push(0);
                    break;
                case 'SEC Filings': alertsTypeCode.push(1);
                    break;
                default: break;
            }
            return item;
        });
        params.alertsType = alertsTypeCode.join(',');
        saveSubscribe(params)
            .then(() => {
                message.success('Success');
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            })
            .catch(() => {
                message.info('Error');
            });
    }

    function setCheckBoxValue(list) {
        setCheckedList(list);
        form.setFieldsValue({
            alertsType: list
        });
    }

    function onChange(list) {
        if (list.length === plainOptions.length - 1) {
            if (list.includes('All Alert')) {
                if (checkedList.includes('All Alert')) {
                    list.splice(list.findIndex(item => item === 'All Alert'), 1);
                    setCheckBoxValue(list);
                }
                else {
                    setCheckBoxValue(plainOptions);
                }
            }
            else if (checkedList.length === plainOptions.length) {
                setCheckBoxValue([]);
            }
            else {
                setCheckBoxValue(plainOptions);
            }
        }
        else if (list.includes('All Alert')) {
            setCheckBoxValue(plainOptions);
        }
        else {
            setCheckBoxValue(list);
        }
    }

    function handleClick() {
        history.push('/contact/unsubscribe');
    }

    return (
        <div className="investor-content">
            {
                isMobile && (
                    <>
                        <div className="investor-content-title">
                            Investor Alerts
                        </div>
                        <Divider />
                    </>
                )
            }
            <div className="investor-prompt">
                Subscribe to our Email alerts
            </div>

            <Form
                form={form}
                layout="vertical"
            >
                <Form.Item
                    label="Name"
                    name="username"
                    rules={[
                        {
                            required: true,
                            message: 'This field is required'
                        }
                    ]}
                >
                    <Input autoComplete="off" />
                </Form.Item>
                <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                        {
                            required: true,
                            message: 'This field is required'
                        },
                        {
                            type: 'email',
                            max: 100,
                            message: 'Please input a valid email address'
                        }
                    ]}
                >
                    <Input autoComplete="off" />
                </Form.Item>
                <Form.Item
                    label="Company"
                    name="company"
                >
                    <Input autoComplete="off" />
                </Form.Item>
                <Form.Item
                    label="Phone"
                    name="phone"
                >
                    <Input autoComplete="off" />
                </Form.Item>
                <Form.Item
                    label="Customize Alerts"
                    name="alertsType"
                    rules={[
                        {
                            required: true,
                            message: 'This field is required'
                        }
                    ]}
                >
                    <Checkbox.Group options={plainOptions} value={checkedList} onChange={onChange} />
                </Form.Item>
                <Form.Item>
                    <Button
                        className={isMobile ? 'form-btn' : ''}
                        type={isMobile ? 'text' : 'primary'}
                        onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                </Form.Item>
            </Form>

            <Button
                className="investor-subscibe"
                type="link"
                onClick={handleClick}
            >
                I want to unsubscribe
            </Button>
        </div>
    );
}

export default Investor;
